import React from "react";

const SubjectCard = ({
  subject_image,
  subject_progress = 0,
  subject_title,
  exam_type,
  isHovered,
  setIsHovered,
}) => {
  const progress = Math.max(0, Math.min(100, Number(subject_progress) || 0));
  const hasProgress = progress > 0;

  const getStatus = (p) => (p === 100 ? "Completed" : "In Progress");

  const releaseDate =
    subject_title === "Mathematics"
      ? "April 2026"
      : "Coming Soon";

  return (
    <div
      className="w-full rounded-2xl bg-black/60 border border-white/10 shadow-lg overflow-hidden"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <div className="relative">
        <div className="h-[160px] sm:h-[175px] lg:h-[190px] overflow-hidden">
          <img
            src={subject_image}
            alt={`${subject_title} cover`}
            className={`w-full h-full object-cover transition duration-300
              ${isHovered ? "grayscale-0 opacity-100 scale-[1.02]" : "grayscale opacity-85"}
            `}
          />
        </div>

        <div className="absolute top-3 left-3 right-3 flex items-center gap-2 min-w-0 text-white">
          <span className="text-[11px] px-2 py-1 rounded-full bg-black/55 border border-white/15 text-white max-w-[60%] truncate">
            Exam: {exam_type}
          </span>
        </div>

        <div
          className={`absolute inset-0 transition duration-200 ${
            isHovered ? "opacity-100" : "opacity-0 pointer-events-none"
          }`}
        >
          <div className="absolute inset-0 bg-black/40" />

          <div className="absolute bottom-3 left-3 right-3 rounded-xl bg-black/55 border border-white p-3">
            {hasProgress ? (
              <>
                <div className="flex items-center justify-between gap-2">
                  <p className="text-xs font-medium text-emerald-300 truncate">
                    {getStatus(progress)}
                  </p>
                  <p className="text-xs text-white/80 shrink-0">{progress}%</p>
                </div>

                <div className="h-2 bg-white/90 mt-2 rounded-full overflow-hidden">
                  <div
                    className="h-full bg-emerald-500 rounded-full"
                    style={{ width: `${progress}%` }}
                  />
                </div>
              </>
            ) : (
              <p className="text-xs text-white">
                Release Date: <span className="font-semibold">{releaseDate}</span>
              </p>
            )}
          </div>
        </div>
      </div>

      <div className="px-4 pt-2">
        <p className="text-white font-light text-base sm:text-lg leading-tight truncate">
          {subject_title}
        </p>

        <div className="mt-3 h-1.5 bg-white/15 rounded-full overflow-hidden">
          <div
            className="h-full bg-emerald-500 rounded-full transition-all duration-300"
            style={{ width: `${progress}%` }}
          />
        </div>
      </div>
    </div>
  );
};

export default SubjectCard;
